<template>
  <div>
    <app-title>{{$route.name}}</app-title>

    <v-container fluid>
      <v-layout row wrap>
        <v-flex>Start Date:
          <date-picker
            v-model="startDate"
            lang="en-au"
            name="startDate"
            format="DD/MM/YYYY"
            placeholder="dd/MM/YYYY"
          ></date-picker>
        </v-flex>

        <v-flex>End Date:
          <date-picker
            v-model="endDate"
            lang="en-au"
            name="endDate"
            format="DD/MM/YYYY"
            placeholder="dd/MM/YYYY"
          ></date-picker>
        </v-flex>

        <v-flex>
          <v-btn color="success" @click="refresh(`Logins`)">Refresh Logins</v-btn>
          <v-btn color="success" @click="refresh(`Signups`)">Refresh Signups</v-btn>
          <v-btn color="success" @click="refresh(`Orders`)">Refresh Orders</v-btn>
        </v-flex>
      </v-layout>
      <v-container fluid>
        <v-layout row wrap v-if="activities">
          <v-flex xs8>
            <orders-chart
              style="height: 100%; position: 'relative'"
              ref="chart"
              :chartData="chartData"
              :options="chartData.options"
            ></orders-chart>
          </v-flex>
          <v-flex xs4>
            <list-activity :items="activities.datasets[0].data" :title="label" :headers="headers"></list-activity>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import listActivity from "@/components/channelPartners/list-activity";
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapPartnerActions } = createNamespacedHelpers("partner");
import ordersChart from "@/components/customer/orders-chart";
export default {
  name: "ChannelPartnerActivity",
  components: {
    listActivity,
    ordersChart
  },
  data: vm => ({
    label: null,
    timeFormat: "DD/MM/YYYY",

    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      .toISOString()
      .substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    activities: null,
    menu1: false,
    menu2: false,
    headers: [
      {
        text: "Logged In",
        value: "x",
        align: "right",
        sortable: true
      },
      {
        text: "No. Logins",
        value: "y",
        align: "right",
        sortable: true
      }
    ]
  }),
  methods: {
    ...mapPartnerActions(["getPartnerData"]),
    refresh(option) {
      let vm = this;
      vm.label = option;
      let url = null;
      switch (option.toString().toLowerCase()) {
        case "logins":
          url = `dealerPortal/ListChannelPartnersActivity`;

          break;
        case "signups":
          url = `dealerPortal/ListChannelPartnersSignups`;
          break;
        case "orders":
          url = `dealerPortal/DealerOrdersChartData`;
          break;
        default:
          break;
      }
      vm.getPartnerData({
        startDate: vm.startDate,
        endDate: vm.endDate,
        url: url
      })
        .then(data => {
          vm.activities = { datasets: [] };
          if (data.datasets) {
            vm.activities.datasets = data.datasets;
          } else {
            vm.activities.datasets = [{ label: option, data }];
          }
          vm.$refs.chart.refresh();
        })
        .catch(() => {});
    }
  },
  computed: {
    chartData() {
      return {
        type: "line",
        fill: true,
        datasets: this.activities.datasets,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: { display: true, text: "Channel Partner Activity" },

          scales: {
            xAxes: [
              {
                type: "time",
                distribution: "linear",
                displayFormats: {
                  day: "MMM D"
                },
                time: {
                  unit: "day",
                  bounds: "data"
                }
              }
            ]
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.fillheight {
  min-height: 100vh;
}
</style>